import * as React from "react";
import { Checkbox, makeStyles } from "@fluentui/react-components";
import PropTypes from "prop-types";
import "./fluent-overide.scss";

const useStyles = makeStyles({
  root: {
    "& input": {
      height: "100%",
      width: "50%",
    },
    "& label": {
      color: "black",
    }
  },
});

export const FluentCheckbox = ({ checked, onChange, label, name, disabled, required, componentStyle }) => {
  const styles = useStyles();
  
  return (
    <Checkbox
      checked={checked}
      onChange={onChange}
      label={label}
      className={`${componentStyle} fluentInput ${styles.root}`}
      name={name}
      disabled={disabled}
      required={required}
    />
  );
};

FluentCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  disabled: PropTypes.bool,
};